import ChannelRow from '@/features/orders/components/OrderListItem/parts/OrderMetaInfo/parts/ChannelRow'
import DeliveryTypeRow from '@/features/orders/components/OrderListItem/parts/OrderMetaInfo/parts/DeliveryTypeRow'
import PaymentStatusRow from '@/features/orders/components/OrderListItem/parts/OrderMetaInfo/parts/PaymentStatusRow'
import { Order } from '@/features/orders/types/app'
import { FC } from 'react'
import { View } from 'react-native'
import { createStyleSheet, useStyles } from 'react-native-unistyles'

interface OrderMetaInfoProps {
    deliveryTypeCategory?: Order['deliveryType']['typeCategory']
    customerName?: Order['customerName']
    deliveryAddress?: Order['deliveryAddress']
    channel: Order['channel']
    deliveryZone?: Order['deliveryZone']
    paymentType?: Order['paymentType']
}

const OrderMetaInfo: FC<OrderMetaInfoProps> = ({
    deliveryTypeCategory,
    customerName,
    deliveryAddress,
    channel,
    deliveryZone,
    paymentType,
}) => {
    const { styles } = useStyles(stylesheet)

    return (
        <View style={styles.container}>
            <DeliveryTypeRow
                channel={channel}
                deliveryTypeCategory={deliveryTypeCategory}
                customerName={customerName}
                deliveryAddress={deliveryAddress}
            />
            <ChannelRow channel={channel} deliveryZone={deliveryZone} />
            <PaymentStatusRow paymentType={paymentType} />
        </View>
    )
}

const stylesheet = createStyleSheet({
    container: {
        gap: 4,
    },
})

export default OrderMetaInfo
